import { Serializable } from '../../../../core/models/serializable';
import { RangeFilter } from '../../../../shared/models/range.model';

export class PaymentListFilterModel
  implements Serializable<PaymentListFilterModel>
{
  fromObject(object: any): PaymentListFilterModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    return {
      InvoiceCode: this.invoiceCode,
      PaymentCode: this.paymentCode,
      CustomerCredential: this.customerCredential,
      PaymentDate: this.paymentDate,
      DisplayOnlyPositiveAmount: this.displayOnlyPositiveAmount,
    };
  }

  public invoiceCode: string;
  public paymentCode: string;
  public customerCredential: string;
  public paymentDate: RangeFilter<Date>;
  public displayOnlyPositiveAmount: boolean;
}
